import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 25rem;
  }

  h2 {
    font-size: 3rem;
    font-weight: 500;
    margin-bottom: 20px;
  }

  h3 {
    font-size: 2rem;

    font-weight: 100;

    b {
      font-weight: 300;
      text-decoration: underline;
    }
  }

  strong {
    font-weight: 400;
    font-size: 1.3rem;
  }
`;
